import { Controller } from "@hotwired/stimulus"

// Drives the inline-expanding "Get 20% off — leave a quick comment" banner
// on the limit_reached paywall. Collapsed shows a button; clicking expands
// it into a textarea + submit. The submit stays disabled until the textarea
// has non-whitespace content. The close (×) collapses back to the button.
export default class extends Controller {
    static targets = ["collapsed", "expanded", "textarea", "submit", "hint"]

    open() {
        this.collapsedTarget.classList.add("hidden")
        this.expandedTarget.classList.remove("hidden")
        if (this.hasTextareaTarget) this.textareaTarget.focus()
    }

    close() {
        this.expandedTarget.classList.add("hidden")
        this.collapsedTarget.classList.remove("hidden")
    }

    input() {
        const trimmed = this.textareaTarget.value.trim()
        const hasText = trimmed.length > 0
        this.submitTarget.disabled = !hasText

        if (hasText) {
            this.submitTarget.classList.remove("bg-warning-300", "cursor-not-allowed")
            this.submitTarget.classList.add("bg-warning-600", "hover:bg-warning-700", "cursor-pointer")
            if (this.hasHintTarget) {
                this.hintTarget.textContent = this.hintTarget.dataset.charsTemplate.replace("%{count}", trimmed.length)
            }
        } else {
            this.submitTarget.classList.add("bg-warning-300", "cursor-not-allowed")
            this.submitTarget.classList.remove("bg-warning-600", "hover:bg-warning-700", "cursor-pointer")
            if (this.hasHintTarget) {
                this.hintTarget.textContent = this.hintTarget.dataset.emptyHint
            }
        }
    }
}
